export interface GenderConstant {
  label: string;
  value: string;
}

export const GENDER_CONSTANTS: Record<string, GenderConstant> = {
  MALE: {
    label: 'Male',
    value: 'M',
  },
  FEMALE: {
    label: 'Female',
    value: 'F',
  },
  OTHER: {
    label: 'Other',
    value: 'X',
  },
};
